import { createContext, useContext } from 'react'
import { type OrderListDTO } from './utils/transformOrderDataDTO'

export interface ContextOrderProps {
  orders: OrderListDTO[]
}

export const OrderContext = createContext<ContextOrderProps>({
  orders: [],
})

export function useContextOrder() {
  const orderContext = useContext(OrderContext)

  if (!orderContext) throw new Error('useContextOrder has to be used within <useContextOrder.Provider>')

  return orderContext
}
